export const aboutUs = {
  hero: {
    title: "About HKI Media",
    heading: [
      "WE BUILD BRANDS.",
      "WE CREATE STORIES.",
      "WE SHAPE THE FUTURE OF MEDIA.",
    ],
    description:
      "At HKI Media, we believe that every brand has a story worth telling. Our mission is to transform ideas into meaningful experiences through creativity, technology, and strategic thinking.",
  },

  intro: {
    paragraphs: [
      "Founded with the vision of bringing every aspect of media under one roof, HKI Media has evolved into a full-service media and marketing company delivering end-to-end solutions across branding, content production, digital marketing, events, media technology, and reputation management. By combining creative excellence with business strategy, we help organizations connect with audiences, build trust, and achieve measurable growth.",
      "Today, HKI Media is home to a multidisciplinary team of creative professionals, marketers, filmmakers, designers, strategists, and technology experts who collaborate to turn ambitious ideas into impactful campaigns.",
    ],
  },

  story: {
    title: "Our Story",
    paragraphs: [
      "HKI Media was born from a simple realization: great ideas often lose their impact when strategy, production, marketing, and execution are handled by different teams.",
      "Instead of making brands coordinate with multiple agencies, we built one integrated ecosystem where every stage of the creative journey works together—from the first brainstorming session to the final campaign launch.",
      "This unified approach enables faster execution, consistent storytelling, stronger brand identity, and better business results.",
    ],
  },

  founder: {
    kicker: "Meet Our Founder",
    name: "Abhimanyu Sihag",
    role: "Founder, HKI Media",
    paragraphs: [
      "At the heart of HKI Media is Abhimanyu Sihag, whose journey in the media and creative industry has shaped the company into what it is today.",
      "With a strong understanding of content, advertising, production and the ever changing media landscape, Abhimanyu founded HKI Media with a clear idea to bring creative thinking and strong execution together under one roof.",
      "Over the years, HKI Media has grown from working on content and television to creating campaigns, films, digital content and communication solutions for brands across industries. The company's work has been driven by the belief that every brand has a story to tell and the right idea can make that story memorable.",
      "Abhimanyu continues to be closely involved in the creative and strategic direction of HKI Media, working alongside the team and clients to turn ideas into work that is relevant, engaging and effective.",
      "His approach is simple: stay curious, think creatively, understand the audience and make work that people remember.",
    ],
    closingNote:
      "That philosophy continues to be at the core of HKI Media a team built around ideas, creativity and the people who bring them to life.",
  },

  whatWeDo: {
    title: "What We Do?",
    description:
      "We provide comprehensive media and communication solutions designed to help businesses grow in today's fast-changing digital world.",
    expertise: [
      "Brand Strategy & Positioning",
      "Digital Marketing",
      "Social Media Management",
      "Creative Design & Content Production",
      "Video Production & Ad Films",
      "Corporate & Commercial Films",
      "Event Management & Brand Experiences",
      "Online Reputation Management (ORM)",
      "Media Technology Solutions",
    ],
    closingNote:
      "Every project is driven by research, creativity, innovation, and measurable outcomes.",
  },

  ecosystem: {
    title: "More Than a Media Company",
    description:
      "HKI Media is building an ecosystem that empowers both businesses and creators.",
    initiatives: ["GigMatic.ai", "GigMatic Studios", "ICASA"],
    closingNote:
      "Through these initiatives, we are expanding opportunities in media, entertainment, AVGC-XR, creator education, and creative entrepreneurship. Our vision extends beyond marketing—we are creating platforms that nurture talent, enable collaboration, and shape the future of India's creative economy.",
  },

  mission: {
    title: "Our Mission",
    description:
      "To empower brands, businesses, and creators through innovative media solutions that inspire audiences, build lasting relationships, and create measurable business impact.",
  },

  vision: {
    title: "Our Vision",
    description:
      "To become India's most trusted integrated media ecosystem by combining creativity, technology, education, and innovation to shape the future of storytelling and digital communication.",
  },

  values: [
    {
      title: "Creativity First",
      description: "We believe powerful ideas create lasting impressions.",
    },
    {
      title: "Innovation",
      description:
        "We embrace emerging technologies and evolving media to stay ahead of the industry.",
    },
    {
      title: "Integrity",
      description:
        "Transparency, trust, and accountability guide every partnership we build.",
    },
    {
      title: "Collaboration",
      description:
        "Great work happens when diverse talents come together with one shared purpose.",
    },
    {
      title: "Excellence",
      description:
        "From strategy to execution, we strive for quality in everything we create.",
    },
  ],

  whyChooseUs: {
    title: "Why Choose HKI Media?",
    items: [
      "End-to-end media and marketing solutions",
      "Strategy-driven creative execution",
      "Experienced multidisciplinary team",
      "Modern production capabilities",
      "Technology-powered marketing ecosystem",
      "Client-focused approach with measurable results",
      "One trusted partner for every stage of brand growth",
    ],
  },

  lookingAhead: {
    title: "Looking Ahead",
    paragraphs: [
      "As media continues to evolve, HKI Media remains committed to pushing creative boundaries, embracing new technologies, and building meaningful connections between brands and people.",
      "We don't just create campaigns—we create experiences, build communities, and help brands leave a lasting impact.",
    ],
  },
};

export default aboutUs;
